import React from "react";

export const Login = React.lazy(() => import("./Login/index.page"));
export const Otp = React.lazy(() => import("./Otp/index.page"));

export const Dashboard = React.lazy(() => import("./Dashboard/index.page"));
export const Tables = React.lazy(() => import("./Tables/index.page"));
export const Employee = React.lazy(() => import("./Employee/index.page"));
export const News = React.lazy(() => import("./News/index.page"));
export const Articles = React.lazy(() => import("./Articles/index.page"));
export const Application = React.lazy(() => import("./Application/index.page"));
export const MyTeam = React.lazy(() =>
  import("./MyTeamFolder/MyTeam/index.page")
);
export const MyOpinion = React.lazy(() =>
  import("./MyOpinionFolder/MyOpinion/index.page")
);
export const MyDevelopment = React.lazy(() =>
  import("./MyDevelopmentFolder/MyDevelopment/index.page")
);
export const Vitality = React.lazy(() => import("./Vitality/index.page"));
export const Onboarding = React.lazy(() =>
  import("./OnboardingFolder/Onboarding/index.page")
);
export const Academy = React.lazy(() =>
  import("./AcademyFolder/Academy/index.page")
);
export const BoxModule = React.lazy(() => import("./BoxFolder/Box/index.page"));
export const Agenda = React.lazy(() =>
  import("./AgendaFolder/Agenda/index.page")
);
export const Keys = React.lazy(() => import("./Keys/index.page"));
export const Settings = React.lazy(() => import("./Settings/index.page"));
export const EditEmployee = React.lazy(() =>
  import("./EditEmployee/index.page")
);
export const OnboardingTask = React.lazy(() =>
  import("./OnboardingFolder/OnboardingTask/index.page")
);
export const OnboardingQuiz = React.lazy(() =>
  import("./OnboardingFolder/OnboardingQuiz/index.page")
);
export const OnboardingTemplate = React.lazy(() =>
  import("./OnboardingFolder/OnboardingTemplate/index.page")
);
export const MyDevelopmentGoal = React.lazy(() =>
  import("./MyDevelopmentFolder/DevelopmentGoal/index.page")
);
export const MyDevelopmentBlog = React.lazy(() =>
  import("./MyDevelopmentFolder/Blog/index.page")
);
export const AssignGoalToTeam = React.lazy(() =>
  import("./MyDevelopmentFolder/AssignGoalToTeam/index.page")
);
export const MyDevelopmentForm = React.lazy(() =>
  import("./MyDevelopmentFolder/MyDevelopmentForm/index.page")
);
export const AddMyTeam = React.lazy(() =>
  import("./MyTeamFolder/AddMyTeam/index.page")
);
export const AddTeamTodo = React.lazy(() =>
  import("./MyTeamFolder/AddTeamTodo/index.page")
);
export const Lesson = React.lazy(() =>
  import("./AcademyFolder/AddLesson/index.page")
);
export const Course = React.lazy(() =>
  import("./AcademyFolder/AddCourse/index.page")
);
export const Chapter = React.lazy(() =>
  import("./AcademyFolder/AddChapter/index.page")
);
export const Category = React.lazy(() =>
  import("./AcademyFolder/AddCategory/index.page")
);
export const AddForm = React.lazy(() =>
  import("./MyDevelopmentFolder/MyDevelopmentForm/add_form")
);

export const BookAsset = React.lazy(() =>
  import("./BoxFolder/BookAsset/index.page")
);
export const AssetCategory = React.lazy(() =>
  import("./BoxFolder/AssetCategory/index.page")
);
export const Asset = React.lazy(() => import("./BoxFolder/Asset/index.page"));
export const TodoSubmission = React.lazy(() =>
  import("./MyTeamFolder/TodoSubmission/index.page")
);
export const ReadForm = React.lazy(() =>
  import("./FormList/ReadForm/index.page")
);
export const KeyFolder = React.lazy(() => import("./Keys/Key/index.page"));
export const FormList = React.lazy(() => import("./FormList/index.page"));
export const CalendarEvent = React.lazy(() =>
  import("./AgendaFolder/AddCalendarEvent/index.page")
);
export const EventType = React.lazy(() =>
  import("./AgendaFolder/AddEventType/index.page")
);
export const Report = React.lazy(() =>
  import("./OnboardingFolder/OnboardingQuizReport/index")
);
export const Submission = React.lazy(() => import("./Submission/Submission"));
export const FormBuilder = React.lazy(() =>
  import("./FormBuilder2/index.page")
);
export const AddLeaveType = React.lazy(() =>
  import("./HRMS/AddLeaveType/index.page")
);
export const AddLeaveAllowcation = React.lazy(() =>
  import("./HRMS/AddLeaveAllowcation/index.page")
);
export const HR = React.lazy(() => import("./HRMS/Hr/index.page"));
export const LeaveSettings = React.lazy(() =>
  import("./HRMS/LeaveSetting/index.page")
);
export const AddHoliday = React.lazy(() =>
  import("./HRMS/Hr/Holiday/AddHoliday/index.page")
);
export const AddLeavePolicy = React.lazy(() =>
  import("./HRMS/LeaveSetting/AddLeavePolicy/index.page")
);
export const AddLeaveRequest = React.lazy(() =>
  import("./HRMS/AddLeaveRequest/index.page")
);
export const AddLeaveBlock = React.lazy(() =>
  import("./HRMS/LeaveSetting/BlockLeave/AddBlockLeave/index.page")
);
export const DocTypeRead = React.lazy(() => import("./FormList/DocTypeRead"));
